import type { ColDef } from 'ag-grid-enterprise'
import type { IAppSummary } from '~/types/application'

import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { textColDef } from '~/utils/table'

const getColumns = (apps: IAppSummary[]): ColDef[] => [
  textColDef(TextCellRenderer, {
    field: 'app_key',
    filter: 'agSetColumnFilter',
    filterParams: {
      buttons: ['clear'],
      defaultToNothingSelected: true,
      suppressSelectAll: true,
      values: apps.map(({ app_key }) => app_key),
    },
    headerName: 'App key',
    maxWidth: 500,
  }),
  textColDef(TextCellRenderer, {
    field: 'key',
    headerName: 'Key',
    resizable: false,
    suppressHeaderMenuButton: true,
  }),
]

export default getColumns
